import type { ColumnDef } from "@tanstack/react-table";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import {
  DataTable,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/data-table";
import { useListMouldsQuery } from "@/services/backend/mould/service";
import type { Mould } from "@/services/backend/mould/mould";
import { EditMouldDialog } from "./edit-mould-dialog";
import DeleteMouldButton from "./delete-mould-button";

const tableColumns: ColumnDef<Mould>[] = [
  {
    id: "description",
    accessorKey: "description",
    header: "Beschreibung",
    cell: ({ row }) => {
      const mouldData = row.original;
      return <div>{mouldData.description}</div>;
    },
  },
  {
    id: "Optionen",
    accessorKey: "id",
    header: "Optionen",
    cell: ({ row }) => (
      <div className="flex flex-row items-center space-x-2">
        <EditMouldDialog mould={row.original} />
        <DeleteMouldButton mouldId={row.original.id} />
      </div>
    ),
  },
];

export function MouldListTable() {
  const {
    data: list,
    isLoading,
    isFetching,
    error,
  } = useListMouldsQuery(
    {
      isYeast: {
        active: true,
        values: [false],
      },
    },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const table = useDataTableController(tableColumns, list?.items || []);

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <DataTableContainer>
      <DataTable
        table={table}
        columns={tableColumns}
        isLoading={isLoading || isFetching}
      />
    </DataTableContainer>
  );
}
